export enum SUBSCRIPTION_PAGE_TYPE {
  SUBSCRIPTION_LIST = 'subscriptionList',
  SUBSCRIPTION_DETAILS = 'subscriptionDetails'
}
